import { createReducer } from 'typesafe-actions';
import { Dictionary } from '../../../../types/globals';
import { dataFetchActions, DataFetchActionsType } from './actions';

export interface RequestState {
    requestId: string;
    isFetching: boolean;
    isFetchingComplete?: boolean;
    error?: Error | string;
}

export type DataFetchingState = Dictionary<RequestState>;

const dataFetchingReducer = createReducer<DataFetchingState, DataFetchActionsType>({})
    .handleAction(dataFetchActions.failure, (state, { payload }) => {
        return {
            ...state,
            [payload.requestIssuer]: {
                requestId: payload.identifier,
                isFetching: false,
                isFetchingComplete: true,
                error: payload.error,
            },
        };
    })
    .handleAction(dataFetchActions.success, (state, { payload }) => {
        return {
            ...state,
            [payload.requestIssuer]: {
                requestId: payload.identifier,
                isFetching: false,
                isFetchingComplete: true,
                error: undefined,
            },
        };
    })
    .handleAction(dataFetchActions.request, (state, { payload }) => {
        return {
            ...state,
            [payload.requestIssuer]: {
                requestId: payload.identifier,
                isFetching: true,
                isFetchingComplete: false,
                error: undefined,
            },
        };
    });

export default dataFetchingReducer;
